import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { queryClient } from 'providers/AllProviders';
import { useParams } from 'react-router-dom';
import { InboundSipTrunkResponse } from './types';
import { createInboundSipTrunk, deleteInboundSipTrunk, getInboundSipTrunk, updateInboundSipTrunk } from './api';

export function useGetInboundSipTrunk(options?: UseQueryOptions<InboundSipTrunkResponse, Error>) {
  const { locationId, agentId } = useParams<{ locationId: string; agentId: string }>();

  return useQuery<InboundSipTrunkResponse>({
    queryKey: ['inbound_sip_trunk', locationId, agentId],
    queryFn: () => getInboundSipTrunk(locationId!, agentId!),
    enabled: Boolean(locationId && agentId),
    ...options
  });
}

export function useCreateInboundSipTrunk() {
  const { locationId, agentId } = useParams<{ locationId: string; agentId: string }>();

  return useMutation({
    mutationFn: (payload: any) => createInboundSipTrunk(locationId!, agentId!, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['inbound_sip_trunk', locationId, agentId],
        refetchType: 'active'
      });
    }
  });
}

export function useUpdateInboundSipTrunk() {
  const { locationId, agentId } = useParams<{ locationId: string; agentId: string }>();

  return useMutation({
    mutationFn: (payload: any) => updateInboundSipTrunk(locationId!, agentId!, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['inbound_sip_trunk', locationId, agentId],
        refetchType: 'active'
      });
    }
  });
}

export function useDeleteInboundSipTrunk() {
  const { locationId, agentId } = useParams<{ locationId: string; agentId: string }>();

  return useMutation({
    mutationFn: () => deleteInboundSipTrunk(locationId!, agentId!),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['inbound_sip_trunk', locationId, agentId],
        refetchType: 'active'
      });
    }
  });
}
